import {
  AlertDialog, AlertDialogTrigger, AlertDialogContent, AlertDialogHeader,
  AlertDialogFooter, AlertDialogTitle, AlertDialogDescription, AlertDialogCancel, AlertDialogAction,
} from "@/components/ui/alert-dialog";

// Reusable destructive-action confirmation. Provide the clickable `trigger`
// element and an `onConfirm` handler. Includes a Description for a11y.
export function ConfirmDelete({ trigger, title = "Ta bort?", description = "Detta går inte att ångra.", confirmLabel = "Ta bort", onConfirm }) {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>
      <AlertDialogContent data-testid="confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display">{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-cancel">Avbryt</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} data-testid="confirm-accept"
            className="bg-[hsl(0_72%_45%)] text-white hover:bg-[hsl(0_72%_40%)] border-0">{confirmLabel}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
